import * as React from 'react'
import LoaderCircleSvg from './assets/loader-circle-svg'

const Spinner = () => <LoaderCircleSvg className="sp-animate-spin" width={24} />

export default Spinner
